import { ActivateProTrial } from "src/app/subscribe/pro-trial/ActivateProTrial";

export const ActivateProTrialPage = () => {
  return <ActivateProTrial />;
};
